import React from "react";
import LocationBanner from "components/locationBanner/index";
import LocalizationMidText from "components/reusableComponents/localizationMidText";
import WhatsAppComp from "components/reusableComponents/whatsappComp";
import CommonUse from "components/LocationReusableComp/commonuse";
import { Data } from "./config";
import TranslationProcess from "components/reusableComponents/translationProcess";
import TrustedTranslation from "components/LocationReusableComp/trustedtranslation";
import Multilangual from "components/reusableComponents/multilangual";
import Translate from "components/reusableComponents/translate";
import WhatChooseUs from "components/homepage/whyChooseUs";
import Reviews from "components/homepage/reviews";
import Scalable from "./scalable";
import TranslateAgency from "components/homepage/translateAgency";
import GetInTouch from "components/getInTouch";
import OrangeStrip from "./orangeStrip";
import NewOrangeStrip from "./NewOrangeStrip";

export default function index() {
  return (
    <>
      <LocationBanner
        backgroundCol="bg-midBlue"
        title="Website Translation Services"
        content="Our website translation services can grow your online presence to reach your international audiences. Translate your web content in over 120 languages in a way search engines will love, enabling your pages to get global traffic. We’re able to provide scalable solutions delivered fast, with the highest certifiable quality, and with a 1-year guarantee."
        formOrangeHead="Get in touch"
        formWhiteHead="with our website translation company"
      />
      {/* <AcadmicInstruction
        backgroundCol="bg-darkBlue"
        head="Website Translation Services Trusted By Tech Companies"
        colorHead="Worldwide"
      /> */}
      <TranslateAgency
        head="Website Translation Services Trusted By Tech Companies "
        colorHead="Worldwide"
        content="95,000 clients have entrusted Tomedes with their business. These include private individuals, small to medium businesses, and the largest corporations, leading brands, national and local governments. But most importantly: we're here for you. Right now.

"
      />
      <LocalizationMidText
        backgroundCol="bg-midBlue"
        orangeMidText="Website"
        content="Translation services help all website owners achieve their global objectives. We provide scalable and guaranteed website solutions that are delivered on time by our team of experts."
      />
      <TrustedTranslation
        backgroundCol="bg-darkBlue"
        headColor="text-lightBlue"
        ColorHead="Website"
        SecondWhite="Translation Services for Every Website Type"
        Content="From e-commerce websites to business websites to financial websites to blogs to government websites to non-profit websites, Tomedes supports every website type from all industries. We provide multilingual solutions that can transform your website into a state-of-the-art international website. If you're thinking of someone to translate your website, think Tomedes. We can broaden your horizons."
      />
      <NewOrangeStrip />
      <Scalable />

      <WhatsAppComp
        backgroundCol="bg-darkBlue"
        fHead="Looking"
        secondHead="for a Website Translator?"
        content="Our website translators and project management team are at your disposal 24/7. If you're looking for a website translator, Tomedes has a network that supports your requirements. We also partner you with a project management team that's knowledgeable about your industry. Why not get started now?"
        btn
      />
      <CommonUse
        backgroundCol="bg-midBlue"
        colorTitleText="Choosing"
        colorTitle="text-orange"
        title="our Website Translation Services Can:"
        data={Data}
        hColor="text-white"
      />
      <TranslationProcess backgroundCol="bg-darkBlue" />
      <TrustedTranslation
        backgroundCol="bg-midBlue"
        headColor="text-orange"
        ColorHead="Professional"
        SecondWhite="Website Translation Services"
        Content="Tomedes focuses on professional website translation as a core element of a comprehensive localization process, which comprises multilingual website's elements combined with localized content. Website translation consists of fine-tuning different aspects of the website based on international standards of multilingual websites and localized market research."
        bottomContent="Our website translators adapt content into any of over 120 languages and 950+ language pairs, converting the formatting, measurement and currency units along with the text strings. Our website translation services have the capability of turning any website into a multilingual one. From a selection of landing pages with multiple languages to multilingual SEO, Tomedes can make things easier for you."
      />
      <Multilangual />
      <Translate
        backgroundCol="bg-midBlue"
        btn
        fHead="Translate"
        content="It would be difficult if not impossible to find a language that Tomedes cannot support with its website translation services. Our network of expert linguists can translate more than 950+ language pairs and can localize for virtually any place worldwide."
        link="/language-translation-service.php"
        linkName="LEARN MORE"
      />
      <OrangeStrip />
      <WhatChooseUs backgroundCol="bg-darkBlue" />
      <Reviews backgroundCol="bg-midBlue" />
      <GetInTouch />
    </>
  );
}
